import { Component, Input, PipeTransform } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { collapseGroupDropdown, initCollapseDropdownFilter } from '@app/helpers/scripts';
import { IDataGenericText, IDataGrouped } from '@app/interfaces/idata-grouped';
import { Address3IndexPipe } from '@app/pipes/address3-index.pipe';
import { Address3NamePipe } from '@app/pipes/address3-name.pipe';
import { PositionIndexPipe } from '@app/pipes/position-index.pipe';
import { PositionNamePipe } from '@app/pipes/position-name.pipe';
import { PlatformService } from '@app/services/platform.service';

@Component({
  selector: 'form-group-checkbox-multi-accordion',
  templateUrl: './form-group-checkbox-multi-accordion.component.html',
  styleUrls: ['./form-group-checkbox-multi-accordion.component.css']
})
export class FormGroupCheckboxMultiAccordionComponent {

  @Input() control: FormControl;
  @Input() controlText: string = ''
  @Input() controlId: string = ''
  @Input() controlArray: FormArray;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() footer: string = '';
  @Input() messageRequired: string = '';
  @Input() placeholderSearch: string = '';
  @Input() showValuesOnPlaceholder: boolean = false;
  @Input() dataSelectGroup: Array<IDataGrouped> = [];
  @Input() dataSelectLabel: Array<IDataGenericText> = [];
  @Input() pipe: 'address3' | 'position' | null = null;
  @Input() textSelectAllGroup: string = '';
  @Input() size: 'lg' | 'default' = 'default';
  @Input() selectionCountAllowed: number = 0;

  public pipeIndex: any = null;
  public pipeName: any = null;
  private currentIndexPipe: PipeTransform = null;
  public countSelectedValues: number = 0;
  public placeholderTextSelected: string = '';
  private _indexElementDisabled: number = -1; // permanent disabled


  constructor(
    private address3IndexPipe: Address3IndexPipe,
    private positionIndexPipe: PositionIndexPipe,
    private platformService: PlatformService) {
  }

  ngOnInit(): void {

    // use only the necessary pipes

    switch (this.pipe) {

      case 'address3':
        this.pipeIndex = Address3IndexPipe;
        this.pipeName = Address3NamePipe;
        this.currentIndexPipe = this.address3IndexPipe;
        break;

      case 'position':
        this.pipeIndex = PositionIndexPipe;
        this.pipeName = PositionNamePipe;
        this.currentIndexPipe = this.positionIndexPipe;
        break;
    }
  }

  ngAfterViewInit() {

    if (this.platformService.isPlatformBrowser) {
      initCollapseDropdownFilter(this.id);
      collapseGroupDropdown();
    }


    if (this.showValuesOnPlaceholder) {
      this.controlArray.valueChanges.subscribe(() => {
        this.getCountSelectedValues();
      })
    }
  }

  getCountSelectedValues() {
    this.countSelectedValues = this.controlArray.value.map((checked, i) => checked ? this.dataSelectLabel[i] : null).filter(v => v !== null).length;
  }

  onChangeCheckboxAll(event: any, parent: string) {

    const elementParent = this.dataSelectGroup.find(x => x.parent === parent);

    if (elementParent === undefined)
      return;

    const newValue = event.target.checked === true ? true : false;

    for (let index = 0; index < elementParent.items.length; index++) {

      const elementChild = elementParent.items[index];

      const ix = this.currentIndexPipe.transform(elementChild.id);

      if (ix !== -1) {
        this.controlArray.at(ix).setValue(newValue, { emitEvent: false })
      }
    }

    this.disableUnselectedItems();

    this.controlArray.updateValueAndValidity();
  }

  onChangeCheckbox(event: any, idWrapParent: string, idAllParent: string) {

    this.disableUnselectedItems();

    const element = document.getElementById(idAllParent) as HTMLInputElement;

    if (!element)
      return;

    if (!event.target.checked) {
      element.checked = false;
      return;
    }

    const checkboxes = document.getElementById(idWrapParent).getElementsByClassName('custom-single-check') as HTMLCollectionOf<HTMLInputElement>;

    let allChecked = true;

    for (let i = 0; i < checkboxes.length; i++) {
      const checkbox = checkboxes[i];
      if (checkbox.type === 'checkbox' && !checkbox.checked) {
        allChecked = false;
        break;
      }
    }

    element.checked = allChecked;
  }

  uncheckOptionAll() {
    const checkboxes = document.getElementById(this.id + '-dp').getElementsByClassName('every-check') as HTMLCollectionOf<HTMLInputElement>;

    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
    this.disableUnselectedItems();
  }

  onRemoveOption(event: MouseEvent, index: number) {
    event.stopPropagation();
    this.controlArray.controls[index].setValue(false);
    this.disableUnselectedItems();
  }


  disableUnselectedItems() {

    if (this.selectionCountAllowed === 0)
      return;

    const arrSelected = this.controlArray.getRawValue().map((checked, i) => checked ? this.dataSelectLabel[i] : null).filter(v => v !== null);

    switch (arrSelected.length || 0) {
      case 0:
        this.placeholderTextSelected = '';
        break;

      case 1:
        this.placeholderTextSelected = arrSelected[0].text;
        break;

      default:
        this.placeholderTextSelected = 'Múltiples opciones seleccionadas';
        break;
    }

    if (arrSelected.length >= this.selectionCountAllowed) {
      this.controlArray.controls
        .filter(e => e.value === false)
        .forEach(e => e.disable({ emitEvent: false }));
      return;
    }

    this.controlArray.controls
      .filter(e => e.value === false)
      .forEach(e => e.enable({ emitEvent: false }));

      if (this.indexElementDisabled !== -1) {
      this.controlArray.at(this.indexElementDisabled).disable({ emitEvent: false });
    }

  }

  public get indexElementDisabled(): number {
    return this._indexElementDisabled;
  }

  public set indexElementDisabled(value: number) {
    this._indexElementDisabled = value;
  }
}